<template>
    <div class='container'>
        <div class="content">
            <tips>日常性能点检表</tips>
            <div class="nocheck flc" v-if="$route.query.type == 2">
                <div class="info flc" @click="noCheck = true">未点检反馈</div>
            </div>
            <div class="detail-table">
                <table border="1"  style="text-align:center;">
                    <tr>
                        <th>
                            验收内容&验收标准
                        </th>
                        <!-- <th>验收内容</th>
                        <th style="padding-left:10px;">验收标准</th> -->
                    </tr>
                    <template v-for="(item,index) in CheckInfoList">
                        <tr style="display:block;" class="acceptance">
                            <div>{{index + 1}}. {{item.name}}</div>
                            <div>{{item.sub_name}}</div>
                        </tr>
                        <tr>
                            <div style="width:100%;">
                                <div class="qualified">
                                    <div class="left text_left">是否合格</div>
                                    <div class="right" v-if="!type">
                                        <div class="ok" @click="statusClick(index,'pass')">
                                            <div class="imgbox">
                                                <img v-if="item.checkStatus != 'pass'" src="@/assets/images/user/talk/radio1.png" alt="">
                                                <img v-if="item.checkStatus == 'pass'" src="@/assets/images/user/talk/radio2.png" alt="">
                                            </div>
                                            <div>合格</div>
                                        </div>
                                        <div class="nook" @click="statusClick(index,'fail')">
                                            <div class="imgbox" >
                                                <img v-if="item.checkStatus != 'fail'" src="@/assets/images/user/talk/radio1.png" alt="">
                                                <img v-if="item.checkStatus == 'fail'" src="@/assets/images/user/talk/radio3.png" alt="">
                                            </div>
                                            <div>不合格</div>
                                        </div>
                                    </div>
                                    <div class="right" v-else>
                                        <div class="ok">
                                            <div class="imgbox" >
                                                <img v-if="item.items_state != 1" src="@/assets/images/user/talk/radio1.png" alt="">
                                                <img v-if="item.items_state == 1" src="@/assets/images/user/talk/radio2.png" alt="">
                                                <!-- <img src="@/assets/images/user/talk/radio2.png" alt=""> -->
                                            </div>
                                            <div>合格</div>
                                        </div>
                                        <div class="nook">
                                            <div class="imgbox">
                                                <img v-if="item.items_state != 0" src="@/assets/images/user/talk/radio1.png" alt="">
                                                <img v-if="item.items_state == 0" src="@/assets/images/user/talk/radio3.png" alt="">
                                                <!-- <img src="@/assets/images/user/talk/radio1.png" alt=""> -->
                                            </div>
                                            <div>不合格</div>
                                        </div>
                                    </div>
                                </div>
                                <transition name="fade-transition" mode="out-in">
                                    <div v-show="item.checkStatus || type">
                                        <div class="remark" v-if="!type && item.checkStatus == 'fail'">
                                            <div class="text_left">问题备注</div>
                                            <textarea v-model="item.problem" placeholder="请输入问题描述"></textarea>
                                        </div>
                                        <div class="remark" v-else-if="item.items_mark">
                                            <div class="text_left">问题备注</div>
                                            <textarea v-model="item.items_mark" disabled placeholder="请输入问题描述"></textarea>
                                        </div>
                                        <tips style="margin-left:16px;">上传图片</tips>
                                        <div class="addphotoBox" v-if="!type">
                                            <div class="imgbox" v-for="(item2,index2) in item.files" :key="index2">
                                                <img @click="showimg(index,index2)" :src="getObjectURL(item2)" alt="">
                                                <img src="@/assets/images/user/talk/deletePhoto.png" @click="deletePhoto(index,index2)" alt="">
                                            </div>
                                            <div class="default flc">
                                                <img src="@/assets/images/user/talk/addphoto.png" alt="">
                                                <input type="file" class="upload" @change="addImg(index)" ref="inputer" multiple accept="image/png,image/jpeg,image/gif,image/jpg" />
                                            </div>
                                        </div>
                                        <div class="addphotoBox" v-else>
                                            <div class="imgbox" v-for="(item2,index2) in item.items_attach" :key="index2">
                                                <img @click="showimg2(index,index2)" :src="item2" alt="">
                                                <!-- <img src="@/assets/images/user/talk/deletePhoto.png" @click="deletePhoto(index,index2)" alt=""> -->
                                            </div>
                                            <!-- <div class="default flc">
                                                <img src="@/assets/images/user/talk/addphoto.png" alt="">
                                                <input type="file" class="upload" @change="addImg(index)" ref="inputer" multiple accept="image/png,image/jpeg,image/gif,image/jpg" />
                                            </div> -->
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </tr>
                    </template>
                </table>
            </div>
        </div>
        <div class="btn flc" @click="submit" v-if="!type">提交</div>
        <div class="btn flc" @click="goback" v-else>返回</div>
        <div class="empty"></div>
        <van-popup class="sureagain" v-model="BagainSure">
            <div class="content_popup">
                <div>温馨提示</div>
                <div>是否确认无误</div>
                <div>
                    <div class="lookagain flc" @click="BagainSure = false">再看看</div>
                    <div class="sure flc" @click="sure">确认</div>
                </div>
            </div>
        </van-popup>

        <van-image-preview v-model="BimageShow" :images="imgsrc" @change="onChange" :startPosition="showImgIndex">
        </van-image-preview>


        <!-- 查看不点检原因或者填写不点检原因 -->
        <van-popup class="date-pop" v-model="noCheck">
            <div class="pop-wrap">
                <div class="pop-title">
                    请填写未点检原因
                </div>
                <div class="tips" v-if="!noCheckLook">如无法点检，请3天内提交未点检原因</div>
                <div class="texttare-class">
                    <textarea v-model="noCheckInfo" placeholder="请输入未点检原因"  class="text-style" name="" id="" cols="30" rows="8"></textarea>
                </div>
                <div class="pop-btn-wrap">
                    <div class="pop-btn" @click="noCheck = false">取消</div>
                    <div class="pop-btn" @click="sendNoCheck">提交</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import tips from '@/components/tips/index.vue'
export default {
    components:{
        tips
    },
    data(){
        return {
            detailList:[],
            imgsrc:[],//点击需要展示的图片数组
            showImgIndex:0,//展示的图片索引
            BagainSure:false,//二次确认弹窗
            BimageShow:false,//显示图片弹窗
            type:false,// 判断是填写还是查看的函数,默认是填写
            noCheckInfo:'',//不点检原因
            noCheck:false,//是否显示弹窗
        }
    },
    created () {
        // type 1 查看.type 2 填写
        // id:点检id
        // id2:体验间id
        let { id,type } = this.$route.query
        this.type = type == 1
        // 获取点检信息
        this.$store.dispatch('userTalkAppointV2/ProjectCheckInfo',{check_id:id})
    },
    computed:{
        CheckInfoList () {
            if ( !this.type ) {
                let detailList = this.$store.state.userTalkAppointV2.CheckInfoList
                detailList.map ( i => {
                    i.files = [],
                    i.checkStatus = '',
                    i.problem = ''
                    return i
                })
                this.detailList = detailList
                return detailList
            } else {
                return this.$store.state.userTalkAppointV2.CheckInfoList
            }
        },
        UploadImgUrl () {
            return this.$store.state.userTalkAppointV2.UploadImgUrl
        }
    },
    methods:{
        // 填写不点检原因
        sendNoCheck () {
            let { id } = this.$route.query
            this.$store.dispatch({type:'userTalkAppointV2/ProjectUncheck',check_id:id,reason:this.noCheckInfo}).then( () => {
                this.$toast("提交成功")
                this.$router.go(-1)
            })
        },
        goback () {
            this.$router.go(-1)
        },
        onChange () {},
        showimg (index,index2) {
            this.imgsrc = []
            for (let i = 0; i < this.detailList[index].files.length; i++) {
                console.log(this.getObjectURL(this.detailList[index].files[i],'121123'))
                this.imgsrc.push(this.getObjectURL(this.detailList[index].files[i]))
            }
            this.BimageShow = true
            this.showImgIndex = index2
        },
        showimg2 (index,index2) {
            this.imgsrc = []
            console.log(index,index2,'index');
            console.log( this.CheckInfoList[index],' this.detailList[index]');
            for (let i = 0; i < this.CheckInfoList[index].items_attach.length; i++) {
                this.imgsrc.push(this.CheckInfoList[index].items_attach[i])
            }
            this.BimageShow = true
            this.showImgIndex = index2
        },
        // 确定提交触发的函数
        sure () {
            let _that = this
            // [{"config_id":1,"mark":"\u6b63\u5e38","state":1,"attach":["\/16142579566452.jpg"]}]
            let options = []
            let detailList = _that.detailList
            let { id,id2 } = _that.$route.query
            detailList.map( item => {
                let obj = {
                    config_id:item.id,
                    mark:item.problem,
                    state:item.checkStatus == 'fail'?0:1,
                    attach:item.attach
                }
                options.push(obj)
            })
            // 发送请求
            _that.$store.dispatch({type:'userTalkAppointV2/ProjectCheck',check_id:id,experience_id:id2,items:JSON.stringify(options)}).then (() => {
                _that.BagainSure = false
                _that.$toast('点检成功')
                this.$store.commit("loadSwitch", false);
                this.$router.go(-1)
            })
        },
        // 提交
        submit () {
            let every = this.detailList.every( item => {
                return item.files.length != 0
            })
            if ( every ) {
                this.BagainSure = true
            } else {
                this.$toast('每个点检项目都需要上传图片')
            }
        },
        // 删除图片
        deletePhoto (index,index2) {
            let obj = {}
            for (const key in this.detailList[index]) {
                const element = this.detailList[index][key];
                obj[key] = element
            }
            obj.files.splice(index2,1)
            obj.attach.splice(index2,1)
            this.detailList[index] = {}
            this.detailList[index] = obj
            console.log(this.detailList[index],'this.detailList[index]');
            this.$forceUpdate()

        },
        // 切换是否合格
        statusClick (index,type) {
            let obj = {}
            for (const key in this.detailList[index]) {
                const element = this.detailList[index][key];
                obj[key] = element
            }
            obj.checkStatus = type
            this.detailList[index] = {}
            this.detailList[index] = obj
            this.$forceUpdate()
        },
        // 添加图片
        addImg (index) {
            console.log('触发函数');
            let inputer = this.$refs.inputer[index]
            let files = inputer.files
            console.log(inputer.files,'2222222222222222222');
            let obj = {}
            for (const key in this.detailList[index]) {
                const element = this.detailList[index][key];
                obj[key] = element
            }   
            let attach = obj.attach || []
            for (let index2 = 0; index2 < files.length; index2++) {
                this.getBase64Image(files[index2]).then (res => {
                    attach.push(res)
                })
                console.log(files[index2],'iiii');
            }
            obj.attach = attach
            obj.files = [...obj.files,...files]
            this.detailList[index] = {}
            this.detailList[index] = obj
            console.log(this.detailList[index],'this.detailList[index]');
            this.$forceUpdate()
            inputer.value = null
        },
        // 获取选中图片路径
        getObjectURL(file) {
            var url = null;
            if (window.createObjectURL != undefined) { // basic
                url = window.createObjectURL(file);
            } else if (window.URL != undefined) { // mozilla(firefox)
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) { // webkit or chrome
                url = window.webkitURL.createObjectURL(file);
            }
            return url;
        },
        getBase64Image(img) {
            let _that = this
            return new Promise((resolve,reject) => {
                var reader = new FileReader();
                reader.readAsDataURL(img);
                reader.onload = function(e){
                    _that.$store.dispatch({type:'userTalkAppointV2/UploadImg',file:reader.result}).then( () => {
                        resolve(_that.UploadImgUrl)
                    })
                }
            })
        }
    }
}
</script>
<style lang='scss' scoped>
.fade-transition-enter-active,
.fade-transition-leave-active{
    transition: all 0.3s;
}
.fade-transition-enter {
    opacity: 0;
    transform: translateX(30px);
}
.fade-transition-leave-to{
    opacity: 0;
    transform: translateX(30px);
}
.text_left {
    text-align: left;
}
::v-deep .sureagain {
    overflow: hidden;
    background: #FFFFFF;
    border-radius: 16px;
    border: 2px solid #979797;
    top:22.86%;
    transform:translate(-50%);
}
::v-deep .showImgBox {
    background-color: transparent;
    width: 80%;
    div{
        float: right;
        margin-bottom: 50px;
        .close {
            width: 50px;
            height: 50px;
        }
    }
    .imgInfo {
        width: 100%;
    }
}
.content_popup {
    padding: 44px 28px 38px 28px;
    div:first-child{
        text-align: center;
        margin-bottom: 84px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
    }
    div:nth-child(2) {
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
    }
    div:nth-child(3) {
        display: flex;
        height: 80px;
        margin-top: 164px;
        .lookagain {
            background: #D6D6D6;
            border-radius: 8px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            width: 214px;
            margin-right: 20px;
            height: 80px;
        }
        .sure {
            width: 214px;
            height: 80px;
            background: #318544;
            border-radius: 8px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }
    }
}
.flc{
    display:flex;
    justify-content:center;
    align-items:center;
}
.positionc{
    left:50%;
    transform:translate(-50%);
}

.date-pop {
    width: 76%;
    top: 40.5%;
    border-radius: 16px;
        .pop-wrap {
        height: 520px;
        background: #FFFFFF;
        border-radius: 16px;
        overflow: hidden;

        .pop-title {
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #444444;
            line-height: 44px;
            text-align: center;
            margin-top: 40px;
        }

        .tips {
            text-align: center;
            font-size: 20px;
            color: #818c96;
        }
        .texttare-class {
            margin-top: 20px;
            padding: 0 40px;
            .text-style {
                padding: 20px;
                box-sizing: border-box;
                height: 220px;
                width: 100%;
                border-radius: 16px;
                background: #f7f7f7;
                resize: none;
            }
        }

        .pop-content {
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #318544;
            line-height: 40px;
            text-align: center;
            margin-top: 60px;
            
        }


          .pop-btn-wrap {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            margin-top: 24px;

            .pop-btn {
                width: 208px;
                height: 80px;
                font-size: 28px;
                font-weight: 400;
                line-height: 80px;
                text-align: center;
                border-radius: 12px;

                &:first-child {
                    border: 2px solid #318544;
                    color: #318544;
                }
                &:last-child {
                    background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                    color: #fff;
                }
            }
        }
    }
}
.container {
    width:100%;
    height:100%;
    background: #F0F4F1;
    padding: 28px 24px;
    .content {
        padding: 32px 0 40px;
        background: #FFFFFF;
        border-radius: 12px;
        position: relative;
        .nocheck {
            position: absolute;
            top: 30px;
            right: 44px;
            flex-direction: column;
            .info {
                width: 160px;
                float: right;
                padding: 10px;
                background-color: #639c67;
                border-radius: 10px;
                color: #ffffff;
            }
            .tips {
                clear: both;
                font-size: 20px;
                color: #818c96;
            }
        }
        .detail-table{
            margin: 43px auto 30px;
            width: 100%;
            table{
                width: 100%;
                tr{
                    display:flex;
                    th{
                        color: #858585;
                        border-top: #858585 solid 1px;
                        border-bottom: #858585 solid 1px;
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #858585;
                        padding: 14px 0;
                        &:nth-child(1) {
                            flex: 1;
                            // border-right:#318544 solid 2px;
                        }
                        &:nth-child(2) {
                            flex: 2;
                        }
                    }
                    td{
                        line-height: 50px;
                        width: 162px;
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #444444;
                        &:nth-child(1) {
                            flex: 1;
                        }
                        &:nth-child(2) {
                            flex: 2;
                        }
                    }
                    &:last-child{
                        border-bottom: 0;
                    }
                    margin-bottom: 28px;
                }
                .acceptance {
                    text-align: left;
                    font-size: 30px;
                    padding-left:32px; 
                    div:nth-child(1) {
                        font-size: 32px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        line-height: 36px;
                        color: #232323;
                    }
                    div:nth-child(2) {
                        margin-top: 22px;
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #444444;
                        line-height: 36px;
                    }
                }
            }
        }
        .qualified {
            display: flex;
            justify-content: space-between;
            margin: 30px 0;
            .left {
                flex: 1;
                margin-left: 32px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #318544;
            }
            .right {
                flex: 3;
                display: flex;
                justify-content: space-around;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #444444;
                img {
                    width: 40px;
                    height: 40px;
                    margin-right: 8px;
                }
                .ok {
                    display: flex;
                    align-items: center;
                    margin-left: 44px;
                }
                .nook{
                    display: flex;
                    align-items: center;
                }
            }
        }
        .remark{
            margin: 0 0 32px;
            padding:0 32px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #B1B1B1;
            textarea {
                width: 100% !important;
                height: 172px;
                margin: 26px auto 0;
                background: #F7F7F7;
                border-radius: 8px;
                resize: none;
                padding: 20px;
            }
        }
        .addphotoBox {
            margin: 14px 0 20px 32px;
            display: flex;
            flex-wrap: wrap;
            .default {
                margin-top: 10px;
                width: 158px;
                height: 158px;
                background: #F3F3F3;
                position: relative;
                margin-right: 8px;
                // overflow: hidden;

                img {
                    position: absolute;
                    width: 46px;
                    height: 46px;
                }
                .upload {
                    position: absolute;
                    width: 100%;
                    top: 0;
                    bottom: 0;
                    opacity: 0;
                    z-index: 9;

                }
            }
            .imgbox {
                margin-top: 10px;
                width: 158px;
                height: 158px;
                margin-right: 8px;
                position: relative;
                img:nth-child(1) {
                    width: 158px;
                    height: 158px;
                    object-fit: cover;
                }
                img:nth-child(2) {
                    width: 36px;
                    height: 36px;
                    position: absolute;
                    right: -9px;
                    top: -9px;
                }
            }
        }
    }   
    .btn{
        margin-top: 0;
        padding: 28px 0 ;
        width: 100%;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
        border-radius: 12px;
    }
    .empty {
        width: 100%;
        height: 50px;
        opacity: 0;
    }
}
</style>